import type {ReactElement} from 'react';

import TransactionFilters from './TransactionFilters';
import type {TransactionFiltersProps} from './types';

const TransactionFilterBar = ({
  transactions,
  exportFilters,
  filterCount,
  currentFilters,
  filtersToApply,
  clearFilters,
  selectCurrentFilters,
  selectAppliedFilters,
  handleApplyFilters,
  disableAdvancedFilters,
  currentTabId,
}: TransactionFiltersProps & {
  currentTabId?: 'swift' | 'system' | 'all';
}): ReactElement => (
  <TransactionFilters
    transactions={transactions}
    exportFilters={exportFilters}
    filterCount={filterCount}
    currentFilters={currentFilters}
    filtersToApply={filtersToApply}
    clearFilters={clearFilters}
    selectCurrentFilters={selectCurrentFilters}
    selectAppliedFilters={selectAppliedFilters}
    handleApplyFilters={handleApplyFilters}
    disableAdvancedFilters={disableAdvancedFilters}
    currentTabId={currentTabId}
  />
);
export default TransactionFilterBar;
